import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdBuild, IoMdCheckbox, IoMdCheckmarkCircleOutline, IoMdListBox, IoMdLock, IoMdTrophy } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdHome, MdLightbulb, MdLightbulbOutline, MdLightMode, MdLocationPin, MdSearch } from "react-icons/md";

import OneObjective from "./OneObjective";

import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import logo from '../assets/logo.png';
import partners from '../assets/partners.png';
import { GiCheckMark } from "react-icons/gi";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

		const services = [
			'Participatory Planning, Monitoring and Evaluation',
			'Project Planning and Management',
			'Agriculture and Value Chains',
			'Research and Survey',
			'Business Management Skills and Entrepreneurship',
			'Procurement, Contract Management and Outsourcing',
			'Human Resources Management',
			'Policy and Poverty Analysis',
			'Information, Communication and Technology',
			'Capacity Building'
		];

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ]);

	
	useEffect(() => {
	AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
	AOS.refresh(); // optional: refresh if content changes dynamically
	}, []);
	
		

	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "15px",
				}}
			>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-12">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "capitalize",
											}}
										>
											About Us
										</h1>
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>


				<div className="container">
					<div className="row pt-3">

						<div className="col-md-12 mt-3 mb-3">
							
							<h2 className="text-primary font-bold">
								Welcome to KOBE KONSULT LTD.
							</h2>

							<h5 className="text-dim font-bold mt-3 mb-3">
								 Empowering Transformative Change
							</h5>
							<p
								style={{
									fontSize: "16px"
								}}
							>
								Kobe Konsult is an African-origin management and economic consulting firm. It works with governments, private companies, non-governmental organisations, international bodies, and development partners across the region.
								<br />
								<br />
								Kobe Konsult supports clients who aim to improve social and economic systems in developing economies. It provides research, monitoring, evaluation, and advisory services. It uses quantitative and qualitative methods and follows international standards across all assignments.
								<br />
								<br />
								The firm has carried out projects in Tanzania, Burkina Faso, Ghana, Kenya, Malawi, Mali, Mozambique, Rwanda, Uganda, and Zambia. This experience supports a clear understanding of local systems and the conditions that shape policy and community outcomes.
								<br/>
								Kobe Konsult improves social and economic systems in developing economies through management and economic consulting. 
								<br/>
								We combine field experience with technical expertise to deliver solutions that clients can use immediately.
							</p>
							
						</div>

					</div>
				</div>

				
				<div className="container bg-surface my-5">
					<div className="row g-4 align-items-center p-3 pb-5">
						{/* Icon */}
						<div className="col-md-2 text-center">
							<div
							className="rounded-circle d-inline-flex align-items-center justify-content-center bg-gradient"
							style={{
								width: '64px',
								height: '64px',
								background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
								boxShadow: '0 4px 12px rgba(37, 117, 252, 0.25)',
								transition: 'transform 0.3s ease, box-shadow 0.3s ease',
							}}
							onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
							onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
							>
							<MdLightbulb size={28} color="#fff" />
							</div>
						</div>

						<div className="col-md-10">
							<h3 className="fw-bold mb-3" style={{ fontSize: '1.75rem', color: '#1e293b' }}>
							Our Objective
							</h3>
							<p className="mb-4" style={{ color: '#475569', lineHeight: 1.6 }}>
							We were founded to develop innovative, human-centered strategies that empower clients to reframe challenges—and turn them into opportunities—through practical, evidence-based consultancy.
							</p>
							<p className="mb-0" style={{ color: '#64748b', lineHeight: 1.6 }}>
							Our credibility stems from deep respect for our clients’ time and a commitment to delivering <strong>actionable insights</strong>, not just reports. At the core of our success is our team: seasoned experts with decades of cross-industry and global experience—continuously learning, adapting, and stress-testing ideas to ensure every recommendation is both visionary and executable.
							</p>
						</div>
					</div>
				</div>

				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow:"auto"
						}}
					>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "rgba(0, 0, 0, 0.5)",
								position: "relative",
								zIndex: 1
							}}
						>
						
							<div className="container">
								<div className="row py-5">

									<div className="col-md-12 text-center mb-5">
										<img src={logo} height={100} />
									</div>
								
									<div className="row g-4 mt-3">
										{/* Vision */}
										<div className="col-md-4">
											<div className="h-100 p-4 rounded-3 shadow-sm" style={{ background: '#ffffff', border: '1px solid #e2e8f0' }}>
											<div className="text-center mb-4">
												<span className="d-inline-block px-3 py-1 rounded-pill bg-primary-subtle text-primary fw-semibold mb-3" style={{ fontSize: '0.875rem' }}>
												Vision
												</span>
												<h3 className="h5 fw-bold text-dark mb-3">Supporting Africa’s Transformation</h3>
												<div className="w-12 bg-primary mx-auto" style={{ height: '2px' }}></div>
											</div>
											<p className="text-muted mb-0" style={{ lineHeight: 1.6, fontSize: '1rem' }}>
												To support the transformation of African economies through consulting that drives sustainable development.
											</p>
											</div>
										</div>

										{/* Mission */}
										<div className="col-md-4">
											<div className="h-100 p-4 rounded-3 shadow-sm" style={{ background: '#ffffff', border: '1px solid #e2e8f0' }}>
											<div className="text-center mb-4">
												<span className="d-inline-block px-3 py-1 rounded-pill bg-success-subtle text-success fw-semibold mb-3" style={{ fontSize: '0.875rem' }}>
												Mission
												</span>
												<h3 className="h5 fw-bold text-dark mb-3">Guided by Evidence, Driven by Impact</h3>
												<div className="w-12 bg-success mx-auto" style={{ height: '2px' }}></div>
											</div>
											<p className="text-muted mb-0" style={{ lineHeight: 1.6, fontSize: '1rem' }}>
												To provide governments, organisations, and communities with guidance and data-driven insights through research, evaluations, and advisory services.
											</p>
											</div>
										</div>

										{/* Values */}
										<div className="col-md-4">
											<div className="h-100 p-4 rounded-3 shadow-sm" style={{ background: '#ffffff', border: '1px solid #e2e8f0' }}>
											<div className="text-center mb-4">
												<span className="d-inline-block px-3 py-1 rounded-pill bg-info-subtle text-info fw-semibold mb-3" style={{ fontSize: '0.875rem' }}>
												Values
												</span>
												<h3 className="h5 fw-bold text-dark mb-3">Our Values</h3>
												<div className="w-12 bg-info mx-auto" style={{ height: '2px' }}></div>
											</div>
											<ul className="list-unstyled text-muted mb-0" style={{ lineHeight: 1.7, fontSize: '1rem' }}>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Intellectual honesty</span>
												</li>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Integrity</span>
												</li>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Client focus</span>
												</li>
												<li className="d-flex align-items-start mb-2">
												<span className="me-2">•</span> <span>Ethical conduct</span>
												</li>
												<li className="d-flex align-items-start">
												<span className="me-2">•</span> <span>Continuous learning</span>
												</li>
											</ul>
											</div>
										</div>
										</div>
								</div>							
							</div>						
						</div>
					</div>

					<div className="container py-5">
						<div className="row justify-content-center">
							<div className="col-lg-10">
							{/* Header */}
							<div className="text-center mb-5">
								<h2 className="fw-bold text-dark mb-3" style={{ fontSize: '1.875rem', lineHeight: 1.3 }}>
								Our Coverage & Network
								</h2>
								<p className="text-muted mb-0" style={{ fontSize: '1.125rem', lineHeight: 1.6, maxWidth: '800px', margin: '0 auto' }}>
								We work through collaborating offices across Africa and a network of specialists with experience in:
								</p>
							</div>

							{/* Services Grid */}
							<div className="row g-4">
								{services.map((service, index) => (
								<div key={index} className="col-md-6 col-lg-4 d-flex align-items-start">
									<div className="me-3 mt-1 flex-shrink-0" aria-hidden="true">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<circle cx="12" cy="12" r="10" fill="#2563eb" opacity="0.12"/>
										<path d="M9 12L11 14L15 10" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
									</div>
									<p className="mb-0" style={{ color: '#334155', fontSize: '1rem', lineHeight: 1.6 }}>
									{service}
									</p>
								</div>
								))}
							</div>

							{/* Optional subtle footer accent */}
							<div className="text-center mt-5 pt-4 border-top border-gray-200">
								<p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
								Our multi-disciplinary team brings proven, hands-on experience across sectors and geographies.
								</p>
							</div>
							</div>
						</div>
					</div>

					<div className="container mb-5 bg-surface p-3 rounded">
						<div className="row">
							<div className="col-md-12">
							{/* Header */}
							<div className="text-center mb-5">
								<h2 className="fw-bold text-dark mb-3">Sectors We Serve</h2>
								<p className="text-muted mx-auto" style={{ fontSize: '1.125rem', lineHeight: 1.6, maxWidth: '720px' }}>
								Kobe Konsult serves institutions working to reduce poverty and strengthen development outcomes across Africa.
								</p>
							</div>

							{/* Sectors Grid */}
							<div className="row g-4">
								{[
								{ label: 'Public Sector', icon: '🏛️', class: "col-md-6 col-sm-6" },
								{ label: 'Private Sector', icon: '🏢', class: "col-md-6 col-sm-6" },
								{ label: 'Development Agencies', icon: '🌍', class: "col-md-4 col-sm-6" },
								{ label: 'NGOs', icon: '🤝', class: "col-md-4 col-sm-6" },
								{ label: 'Faith-Based Organisations', icon: '🕊️', class: "col-md-4 col-sm-6" }
								].map((sector, i) => (
								<div key={i} className={sector.class}>
									<div className="d-flex align-items-start p-4 bg-background rounded-3 h-100">
									<span className="me-3 fs-4" aria-hidden="true">{sector.icon}</span>
									<div>
										<h5 className="fw-bold text-dark mb-2">{sector.label}</h5>
										<p className="text-muted mb-0" style={{ fontSize: '0.95rem', lineHeight: 1.5 }}>
										Government ministries, agencies, and local authorities driving policy and service delivery.
										</p>
									</div>
									</div>
								</div>
								))}
							</div>

							{/* Optional compact list version (for mobile fallback or tighter space) — uncomment if preferred */}
							{/* 
							<div className="bg-light rounded-3 p-4 mt-4">
								<h5 className="fw-bold text-primary mb-3">Key Partners</h5>
								<ul className="list-unstyled" style={{ fontSize: '1.05rem', lineHeight: 1.7 }}>
								{['Public sector', 'Private sector', 'Development agencies', 'NGOs', 'Faith-based organisations'].map((s, i) => (
									<li key={i} className="d-flex align-items-start mb-2">
									<span className="me-2 text-primary" style={{ marginTop: '0.2rem' }}>✓</span>
									<span>{s}</span>
									</li>
								))}
								</ul>
							</div>
							*/}
							</div>
						</div>
						</div>

					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="text-primary font-semi-bold">
									Our Unique Strengths
								</h3>
							</div>

							<div className="col-md-12 mt-3" data-aos="fade-right">
								<div className="row bg-secondary pb-3">
									<div 
										className="col-md-2 flex-shrink-0 pt-3"
										style={{
											display: "grid",
											placeItems: "center"
										}}
								>
										<IoMdTrophy size={68} />
									</div>
									<div className="col-md-10">
										<h5 className="text-center font-semi-bold mt-3">
											GOAL AND EXPERTISE
										</h5>
										<hr/>
										<h5
											style={{
												textAlign: "justify"
											}}
										>
											We always bring fresh and innovative approach to consulting services. Our goal is to exceed the expectations of every client by offering outstanding services, increased flexibility, and greater value, thus optimizing our functionality and improving operational efficiency.  Our firm and associates are distinguished by their functional and technical expertise combined with their hands-on experience, thereby ensuring that our clients receive the most effective and professional attention. 
										</h5>
									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3" data-aos="fade-right">
								<div className="row bg-secondary pb-3">
									<div 
										className="col-md-2 flex-shrink-0 pt-3"
										style={{
											display: "grid",
											placeItems: "center"
										}}
								>
										<IoMdListBox size={68} />
									</div>
									<div className="col-md-10">
										<h5 className="text-center font-semi-bold mt-3">
											CLIENT NEEDS
										</h5>
										<hr/>
										<h5
											style={{
												textAlign: "justify"
											}}
										>
											Our extensive skills encompass all aspects of implementation and operation, including business requirements definition, development of well-designed needs for client approval, design, and overseeing development teams customizing <i>‘knowledge’</i> to fit specific client needs on-site.
										</h5>
									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3" data-aos="fade-right">
								<div className="row bg-secondary pb-3">
									<div 
										className="col-md-2 flex-shrink-0 pt-3"
										style={{
											display: "grid",
											placeItems: "center"
										}}
								>
										<IoMdBuild size={68} />
									</div>
									<div className="col-md-10">
										<h5 className="text-center font-semi-bold mt-3">
											PROJECT IMPLEMENTATION
										</h5>
										<hr/>
										<h5
											style={{
												textAlign: "justify"
											}}
										>
											We pride ourselves on our proven track record for effectively administering multiple implementations that are met within budget restraints and time schedules. 
										</h5>
									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3" data-aos="fade-right">
								<div className="row bg-secondary pb-3">
									<div 
										className="col-md-2 flex-shrink-0 pt-3"
										style={{
											display: "grid",
											placeItems: "center"
										}}
								>
										<IoMdCheckmarkCircleOutline size={68} />
									</div>
									<div className="col-md-10">
										<h5 className="text-center font-semi-bold mt-3">
											VALUES & KNOWLEDGE
										</h5>
										<hr/>
										<h5
											style={{
												textAlign: "justify"
											}}
										>
											We maintain an extensive knowledge base of qualified consultants who excels in intellectual honesty and integrity, high client focus-customer service and reporting.    
										</h5>
									</div>
								</div>
							</div>


						</div>
					</div>

					<div className="container mt-5">
						<h3 className="text-primary font-semi-bold mb-5">
							Our Partners
						</h3>
						<img style={{width:"100%"}} src={partners} />
					</div>

				</div>
			</div>

			
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}